import { render, staticRenderFns } from "./HoldReverseModal.vue?vue&type=template&id=7a973bd6"
import script from "./HoldReverseModal.vue?vue&type=script&lang=js"
export * from "./HoldReverseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports